<template>
  <modal-monitroing-event :active="monitoring" @close="hideModal" :event="subject" :events="events" @sort="setSort" :sort="sort" :selectTab="selectTab" />
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";

import ModalMonitroingEvent from "./ModalMonitoringEvent";

export default {
  name: "modal-monitoring-event-container",
  methods: {
    ...mapActions("modal", ["hide"]),
    ...mapActions("monitoring", ["resetCurrentSubject"]),
    ...mapActions("monitoringSubject", ["fetchSubject", "reset", "setSort", "selectTab"]),
    hideModal() {
      this.hide("monitoring");
      this.resetCurrentSubject()
      this.reset()
    }
  },
  computed: {
    ...mapState("modal", ["monitoring"]),
    ...mapState("monitoring", ["currentSubjectId"]),
    ...mapState("monitoringSubject", ["subject", "sort"]),
    ...mapGetters("monitoringSubject", ["events"])
  },
  components: {
    ModalMonitroingEvent
  },
  created() {
    this.fetchSubject(this.currentSubjectId)
      .then((res) => this.isFetching = false)
      .catch((res) => {
        this.isFetching = false;
      });
  }
};
</script>



// WEBPACK FOOTER //
// ModalMonitoringEventContainer.vue?20d19e18